import { useEffect, useState } from "react";
import { Images } from "lucide-react";
import { api, API } from "../lib/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  const fileUrl = (path) => `${API}/gallery/file?path=${encodeURIComponent(path)}`;

  useEffect(() => {
    api.get("/gallery").then((r) => setImages(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main className="bg-zinc-950 min-h-screen">
      <section className="bg-zinc-950 text-white border-b border-zinc-800">
        <div className="container mx-auto px-6 py-16 max-w-5xl">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#22C55E] mb-4 flex items-center gap-2">
            <Images className="w-3.5 h-3.5" /> Our Work · Gallery
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Rebuilding dreams, one van at a time.</h1>
          <p className="mt-4 text-zinc-300 max-w-xl">A look at some of the repairs and rebuilds we've done here at Nomad Caravan Repairs in Bowen.</p>
        </div>
      </section>

      <section className="container mx-auto px-6 py-12 max-w-5xl">
        {loading ? (
          <div className="text-zinc-400 text-sm">Loading gallery…</div>
        ) : images.length === 0 ? (
          <div data-testid="gallery-empty" className="text-zinc-400 text-sm">No photos yet — check back soon.</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {images.map((img) => (
              <button
                key={img.id}
                data-testid={`gallery-item-${img.id}`}
                onClick={() => setActive(img)}
                className="group relative aspect-square overflow-hidden bg-zinc-900 border border-zinc-800 hover:border-[#16A34A] transition-colors"
              >
                <img
                  src={fileUrl(img.path)}
                  alt={img.caption || img.original_filename || "Gallery photo"}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {img.caption && (
                  <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent text-white text-xs text-left px-3 pt-6 pb-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    {img.caption}
                  </span>
                )}
              </button>
            ))}
          </div>
        )}
      </section>

      {active && (
        <div
          data-testid="gallery-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[90] bg-black/90 flex flex-col items-center justify-center p-6 cursor-zoom-out"
        >
          <img src={fileUrl(active.path)} alt={active.caption || "Gallery photo"} className="max-w-full max-h-[85vh] object-contain" />
          {active.caption && <p className="text-white text-sm mt-4 max-w-2xl text-center">{active.caption}</p>}
        </div>
      )}
    </main>
  );
}
